export const workspaceActionTypes = {
    // INIT — triggered after login / session check
    WORKSPACE_INIT_REQUEST: 'W1',
    WORKSPACE_INIT_SUCCESS: 'W2',
    WORKSPACE_INIT_FAILURE: 'W3',

    // SWITCH active workspace
    WORKSPACE_SWITCH_REQUEST: 'W4',
    WORKSPACE_SWITCH_SUCCESS: 'W5',
    WORKSPACE_SWITCH_FAILURE: 'W13',

    // FETCH TEAMS for current workspace
    WORKSPACE_FETCH_TEAMS_REQUEST: 'W6',
    WORKSPACE_FETCH_TEAMS_SUCCESS: 'W7',
    WORKSPACE_FETCH_TEAMS_FAILURE: 'W8',

    // FETCH MEMBERS for current workspace
    WORKSPACE_FETCH_MEMBERS_REQUEST: 'W9',
    WORKSPACE_FETCH_MEMBERS_SUCCESS: 'W10',
    WORKSPACE_FETCH_MEMBERS_FAILURE: 'W11',

    // RESET — on sign out
    WORKSPACE_RESET: 'W12',

    // CREATE workspace (and chain: list refetch + activate + optional invite)
    WORKSPACE_CREATE_REQUEST: 'W14',
    WORKSPACE_CREATE_SUCCESS: 'W15',
    WORKSPACE_CREATE_FAILURE: 'W16',

    // INVITE MEMBER (used by the create-workspace chain)
    WORKSPACE_INVITE_MEMBER_REQUEST: 'W17',
    WORKSPACE_INVITE_MEMBER_SUCCESS: 'W18',
    WORKSPACE_INVITE_MEMBER_FAILURE: 'W19',

    // UPDATE workspace fields (title, short_name, …)
    WORKSPACE_UPDATE_REQUEST: 'W20',
    WORKSPACE_UPDATE_SUCCESS: 'W21',
    WORKSPACE_UPDATE_FAILURE: 'W22',

    // LEAVE workspace (caller removes their own membership)
    WORKSPACE_LEAVE_REQUEST: 'W23',
    WORKSPACE_LEAVE_SUCCESS: 'W24',
    WORKSPACE_LEAVE_FAILURE: 'W25',

    // ARCHIVE workspace (owner-only; backed the "delete workspace" UX)
    WORKSPACE_ARCHIVE_REQUEST: 'W26',
    WORKSPACE_ARCHIVE_SUCCESS: 'W27',
    WORKSPACE_ARCHIVE_FAILURE: 'W28',

    // REMOVE a member from the workspace (owner/admin)
    WORKSPACE_REMOVE_MEMBER_REQUEST: 'W29',
    WORKSPACE_REMOVE_MEMBER_SUCCESS: 'W30',
    WORKSPACE_REMOVE_MEMBER_FAILURE: 'W31',

    // FETCH pending invites for current workspace (owner/admin)
    WORKSPACE_FETCH_INVITES_REQUEST: 'W32',
    WORKSPACE_FETCH_INVITES_SUCCESS: 'W33',
    WORKSPACE_FETCH_INVITES_FAILURE: 'W34',

    // REVOKE a pending invite (owner/admin)
    WORKSPACE_REVOKE_INVITE_REQUEST: 'W35',
    WORKSPACE_REVOKE_INVITE_SUCCESS: 'W36',
    WORKSPACE_REVOKE_INVITE_FAILURE: 'W37',
};
